module.exports = __webpack_public_path__ + "img/1614857379.612fb502.png";